import { useState } from "react";

import RemainingTimeComponent from "@/main/components/shared/remainingTime/remainingTimeComponent";
import { getTranslateByKey, isNullUndefined, isShowControlByElementId } from "@/main/services/utils";
import { CartState } from "@/main/store/cart";
import { QuoteNoSupplierAssignedResponse } from "@/main/models/response";

import { TypeBoxCart } from "../types";
import * as S from "./styles";
import { Controls } from "@/main/services/constants/constantsControl";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import UpdateIcon from "@mui/icons-material/Update";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import colors from "@/main/style/colors";

import { quoteApi } from "@/main/api";
import { toast } from "react-toastify";
import useAsyncModalConfirm from "@/main/components/shared/asyncModalConfirm/asyncModalConfirm";

interface IRemainingTimeShippingTable {
	cart: QuoteNoSupplierAssignedResponse | null;
	guidQuote: string;
	type?: TypeBoxCart;
	dataCart: CartState;
	loadCart: (guidQuote: string) => void;
	allowCloseOfferRequest?: boolean;
}
function RemainingTimeShippingTable({
	cart,
	guidQuote,
	dataCart,
	loadCart,
	type = "unaswered",
	allowCloseOfferRequest = false,
}: IRemainingTimeShippingTable) {
	const cartNoSupplierAssigned = dataCart.cartItems.dataNoSupplierAssigned;
	const cartDataUnansweredItems = dataCart.cartItems.dataUnansweredItems;

	const [isFinishedTime, setIsFinishedTime] = useState<boolean>(false);
	const [isOfferRequestClosed, setIsOfferRequestClosed] = useState<boolean>(false);
	const [, setIsLoadingSave] = useState(false);
	const [getConfirmation, ModalConfirmation] = useAsyncModalConfirm();

	function handleFinishTime() {
		setIsFinishedTime(true);
		const haveNoSupplierAndUnansweredItems =
			!isNullUndefined(cartNoSupplierAssigned) && !isNullUndefined(cartDataUnansweredItems);
		if (haveNoSupplierAndUnansweredItems && type === "noSupplierAssigned") return;
		loadCart(guidQuote);
	}

	const canCloseOfferRequest =
		allowCloseOfferRequest &&
		!isOfferRequestClosed &&
		cart?.showCloseOfferRequest === true &&
		isShowControlByElementId(Controls.IdCloseOfferRequest);

	async function handleCloseOfferRequest() {
		const isConfirm = await getConfirmation(
			<>
				<S.ConfirmTitle>{getTranslateByKey("information.closeOfferRequestTitle")}</S.ConfirmTitle>
				<S.ConfirmText>{getTranslateByKey("information.closeOfferRequestConfirm")}</S.ConfirmText>
			</>,
		);
		if (!isConfirm) return;

		try {
			const res = await quoteApi.closeOfferRequest(String(guidQuote));
			if (res.data.result) {
				toast.success(getTranslateByKey("information.closeOfferRequestSuccess"));
				setIsOfferRequestClosed(true);
			}
		} catch {
			return;
		} finally {
			loadCart(guidQuote);
		}
	}

	function handleExpireDeadlineAnswer() {
		setIsLoadingSave(true);
		quoteApi
			.expireDeadlineAnswer(String(guidQuote))
			.then((res) => {
				const resData = res.data.result;
				if (resData) {
					toast.success(getTranslateByKey("information.quoteExpiredSucessfully"));
					loadCart(guidQuote);
				}
			})
			.finally(() => setIsLoadingSave(false));
	}

	if (isNullUndefined(cart)) return <></>;

	if (cart.selfSupplied) {
		if (!canCloseOfferRequest) return <></>;

		return (
			<S.ContainterRemainingTime>
				{`- ${getTranslateByKey("information.closeOfferRequest")}:`}
				<Tooltip title={getTranslateByKey("information.closeOfferRequestHelp")}>
					<IconButton
						id="id-createOrder-button-close-offer-request"
						size="small"
						sx={{ ml: 1, color: colors.orange }}
						aria-label={getTranslateByKey("information.closeOfferRequestHelp")}
						onClick={handleCloseOfferRequest}
					>
						<TimerOffIcon fontSize="small" />
					</IconButton>
				</Tooltip>
				<ModalConfirmation confirmLabelKey="information.closeOfferRequestButton" cancelLabelKey="information.cancel" />
			</S.ContainterRemainingTime>
		);
	}

	if (isFinishedTime || !cart.showDeadlineAnswer) return <></>;

	return (
		<S.ContainterRemainingTime>
			{`- ${getTranslateByKey("information.remainingTimeToExpire")}:`}
			<S.ContainterItemRemainingTime>
				<RemainingTimeComponent finishTime={cart.deadlineAnswer} onTimeFinished={handleFinishTime} showExpire={false} />
			</S.ContainterItemRemainingTime>
			{isShowControlByElementId(Controls.IdExpireDeadlineAnswer) && cart.showExpireDeadline && (
				<Tooltip title={getTranslateByKey("control.ExpireDeadlineAnswer")}>
					<IconButton
						id="id-createOrder-button-expire-deadline-answer"
						size="small"
						sx={{ ml: 1 }}
						aria-label={getTranslateByKey("control.ExpireDeadlineAnswer")}
						onClick={async () => {
							const isConfirm = await getConfirmation(getTranslateByKey("information.expirationDateConfirm"));
							if (!isConfirm) return;
							handleExpireDeadlineAnswer();
						}}
					>
						<UpdateIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			)}
			<ModalConfirmation />
		</S.ContainterRemainingTime>
	);
}

export default RemainingTimeShippingTable;
